export enum EventObjectType {
    TEASER = 'teaser',
    TOGGLE = 'toggle',
    LINK = 'link',
    CAROUSEL = 'carousel',
    BUTTON = 'button'
}